/* eslint-disable import/no-cycle */
import Parent from '../views/Parent.vue';

// import report
import ListReportBpjstk from '../views/report-bpjstk/ListReportBpjstk.vue';
import { setBreadcrumb } from './index';

const reportBpjstkRoute = {
  path: '/report-bpjstk',
  children: [
    {
      path: '',
      meta: {
        title: 'BNI QRIS - Report BPJSTK',
        appBarTitle: 'Report BPJSTK',
        breadcrumbs: () => [
          setBreadcrumb('Report BPJSTK', '/report-bpjstk', true),
          setBreadcrumb('List Report BPJSTK', '/report-bpjstk'),
        ],
      },
      component: ListReportBpjstk,
      name: 'ListReportBpjstk',
    },
  ],

  meta: {
    title: 'BNI QRIS - Report BPJSTK',
    appBarTitle: 'Report BPJSTK',
  },
  component: Parent,
};
export default reportBpjstkRoute;
